module.exports = __webpack_public_path__ + "static/media/Dylan_S@3x.5b6c8246.jpg";